class CosBackToTop extends HTMLElement {
  constructor() {
    super();
    this.backToTopInited = false;
    this.observer = null;
    this.trigger = null;
  }

  connectedCallback() {
    this.initBackToTop();
    
    document.addEventListener('search.rendered', () => {
      this.initBackToTop();
    });
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.trigger) {
      this.trigger.remove();
    }
    document.removeEventListener('cos:back-to-top:show', () => {
      this.classList.add('is-visible');
    });
    document.removeEventListener('cos:back-to-top:hide', () => {
      this.classList.remove('is-visible');
    });
  }

  initBackToTop() {
    const grid = document.querySelector('#main'); //document.querySelector('[collection-grid]') || 
    if (!grid) return;

    const triggerPresent = grid.querySelector('[back-to-top-trigger]');
    
    if (this.backToTopInited && triggerPresent) return;
    if (grid.getBoundingClientRect().height === 0) return; 

    this.backToTopInited = true;

    this.trigger = document.createElement('span');
    this.trigger.classList.add('back-to-top-trigger');
    this.trigger.setAttribute('back-to-top-trigger', '');
    grid.appendChild(this.trigger);
    
    this.observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting && grid.getBoundingClientRect().height > 3400) {  
        this.classList.add('is-visible');
      } else {
        this.classList.remove('is-visible');
      }
    }, {
      threshold: 1
    });
    this.observer.observe(this.trigger);

    this.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    });

    document.addEventListener('cos:back-to-top:show', () => {
      this.classList.add('is-visible');
    });
    document.addEventListener('cos:back-to-top:hide', () => {
      this.classList.remove('is-visible');
    });
  }
}

if (!customElements.get('cos-back-to-top')) customElements.define('cos-back-to-top', CosBackToTop);